import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_COMPETITORS_REQUEST, fetchCompetitorFailure, fetchCompetitorSuccess } from "../actions/competitorActions";
import { fetchCompanyKeyCompetitorsTable } from "../../../services/accIqService";


// Worker Saga
function* fetchCompetitorsSaga() {
  try {
    const payload = yield select(state=>state?.competitorsReducer?.payload);
    const data = yield call(fetchCompanyKeyCompetitorsTable,payload);
    yield put(fetchCompetitorSuccess(data));
  } catch (error) {
    yield put(fetchCompetitorFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchCompetitors() {
  yield takeLatest(FETCH_COMPETITORS_REQUEST, fetchCompetitorsSaga);
}
